var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 26,
    viewBox: "0 0 76 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 0L64.5026 1.06885L71.1769 10.4915L76 0ZM33.8479 20.4436L33.2945 21.2765L33.8479 20.4436ZM27.2237 16.0425L26.6703 16.8755L27.2237 16.0425ZM1.56921 25.8222L14.3217 16.9935L13.1833 15.3491L0.43079 24.1778L1.56921 25.8222ZM26.6703 16.8755L33.2945 21.2765L34.4013 19.6107L27.7771 15.2096L26.6703 16.8755ZM48.0028 21.0568L69.2338 6.01818L68.0778 4.38613L46.8467 19.4248L48.0028 21.0568ZM33.2945 21.2765C37.7713 24.2508 43.6168 24.1635 48.0028 21.0568L46.8467 19.4248C43.1355 22.0535 38.1893 22.1274 34.4013 19.6107L33.2945 21.2765ZM14.3217 16.9935C18.0255 14.4294 22.9182 14.3826 26.6703 16.8755L27.7771 15.2096C23.3428 12.2635 17.5605 12.3188 13.1833 15.3491L14.3217 16.9935Z",
    fill: "#76D27E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseGreen);
export default __webpack_public_path__ + "static/media/increase-green.42b90eae897a0777e26db49ac2ef8b4d.svg";
export { ForwardRef as ReactComponent };